import { render } from "./SimpleDateTime.vue?vue&type=template&id=64c6d6bc&scoped=true&ts=true"
import script from "./SimpleDateTime.vue?vue&type=script&lang=ts"
export * from "./SimpleDateTime.vue?vue&type=script&lang=ts"

import "./SimpleDateTime.vue?vue&type=style&index=0&id=64c6d6bc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64c6d6bc"]])

export default __exports__